import { useObservable } from "micro-observables";
import { useServices } from "@core/servicesContext";
import { PaginatedDataResult, PromiseResult, useMappedStore, usePromise } from "@utils/hooks";
import { Group } from "@domain/group/group";
import { AllWallet, Cashable, Disbursement, Earning, TransactionFilterOptions, Wallet } from "./wallet";

export function useWallet(): PromiseResult<AllWallet[] | null> {
	const { walletService } = useServices();
	return usePromise(() => walletService.getWallet(), []);
}

export function useEarning(groupId: string): PromiseResult<Earning | null> {
	const { walletService } = useServices();
	return usePromise(() => walletService.getEarning(groupId), []);
}

export function useCashable(groupId: string): PromiseResult<Cashable | null> {
	const { walletService } = useServices();
	return usePromise(() => walletService.getCashable(groupId), []);
}

export function useShareroomAlias(): Group | null {
	const { groupService } = useServices();
	return useObservable(groupService.shareroomAlias);
}

export function useTransactionLists(
	filterOption: TransactionFilterOptions | undefined,
	group: Group | undefined
): PaginatedDataResult<Wallet> {
	const { walletService } = useServices();
	return useMappedStore({ filterOption, groupId: group?.id ?? "-" }, walletService.alltransactionsStore, [
		filterOption,
		group?.id,
	]);
}

// export function useDisbursementLists(groupId: string): PaginatedDataResult<Disbursement> {
// 	const { walletService } = useServices();
//
// 	return useMappedStore(groupId, walletService.alldisbursementsStore, [groupId]);
// }

export function useDisbursementLists(groupID: string): PromiseResult<Disbursement[] | null> {
	const { walletService } = useServices();
	return usePromise(() => walletService.listDisbursements(groupID), []);
}
